<template>
  <gl-field v-bind="$props" :is-active="isActive" with-vendor-icon>
    <template #default="{ innerId }">
      <vue-multiselect
        :id="innerId"
        :value="valueObj"
        :allow-empty="allowEmpty"
        :block-keys="['Tab']"
        :disabled="disabled"
        :loading="loading"
        :options="options"
        :placeholder="placeholder"
        :searchable="searchable"
        class="plc-field__select"
        track-by="code"
        label="label"
        maxlength="256"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose"
      >
        <template slot="singleLabel" slot-scope="props">
          <slot name="option" :option="props.option"></slot>
        </template>

        <template slot="option" slot-scope="props">
          <slot name="option" :option="props.option"></slot>
        </template>

        <span slot="noResult">{{ $t('Element not found') }}</span>

        <template #caret>
          <gl-svg-icon icon="arrow-down" class="multiselect__caret" />
        </template>
      </vue-multiselect>
    </template>
  </gl-field>
</template>

<script>
import GlField from '@gl/GlField'

import VueMultiselect from 'vue-multiselect'
import GlSvgIcon from '@gl/GlSvgIcon';

export default {
  name: 'GlFieldSelect',
  components: {
    GlSvgIcon,
    GlField,
    VueMultiselect,
  },
  props: {
    value: {
      type: [Object, Number, String],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    isDirectionRow: {
      type: Boolean,
    },
    error: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: () => [],
    },
    searchable: {
      type: Boolean,
    },
    allowEmpty: {
      type: Boolean,
    },
    withBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  computed: {
    valueObj() {
      return (
        this.options.find((i) => i.code === (this.value && this.value.code)) ||
        null
      )
    },
  },
  methods: {
    handleSelect(value) {
      this.$emit('input', value)
    },
    handleOpen() {
      this.isActive = true
    },
    handleClose() {
      this.isActive = false
    },
    // toggle() {
    //   console.log('sdf')
    // },
  },
}
</script>

<style lang="scss">
@import '~styles/vendors/multiselect';
</style>
